import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as evtApi from "../api/events";
import * as commApi from "../api/community";
import bgImg from "../assets/1.png";

export default function EventEdit() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [communities, setCommunities] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);

  const [form, setForm] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const list = await commApi.listCommunities();
        const arr = Array.isArray(list) ? list : (list?.rows ?? []);
        setCommunities(arr);
      } catch { setCommunities([]); }
      try {
        const cats = await evtApi.listCategories();
        setCategories(Array.isArray(cats) ? cats : []);
      } catch { setCategories([]); }
      try {
        const data = await evtApi.getEvent(id);
        setForm({
          ...data,
          social_links: typeof data.social_links === "object" && data.social_links !== null ? data.social_links : {}
        });
      } catch { setError("Unable to load event"); }
    })();
  }, [id]);

  useEffect(() => {
    if (!form?.category) { setSubCategories([]); return; }
    (async () => {
      try {
        const subs = await evtApi.listSubCategories({ categoryName: form.category });
        setSubCategories(Array.isArray(subs) ? subs : []);
      } catch { setSubCategories([]); }
    })();
  }, [form?.category]);

  if (!form) return <div className="min-h-screen flex items-center justify-center">Loading…</div>;

  const handleChange = e => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const payload = { ...form, social_links: form.social_links || {} };
      await evtApi.updateEvent(id, payload);
      navigate("/events");
    } catch (err) {
      setError(err?.response?.data?.error || "Update failed");
    } finally { setLoading(false); }
  };

  return (
    <section className="cf-section" style={{
      backgroundImage:`url(${bgImg}), linear-gradient(135deg, rgba(210,168,87,.7), rgba(139,186,161,.7), rgba(5,102,117,.7))`,
      backgroundSize:'cover', backgroundPosition:'center', padding:'1rem', minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center'
    }}>
      <form onSubmit={handleSubmit} style={{ width:'100%', maxWidth: '40rem', background:'#ffffffc7', borderRadius:'1rem', boxShadow:'0 10px 25px rgba(0,0,0,.1)', padding:'1.25rem', display:'grid', gap:'.8rem', gridTemplateColumns:'repeat(2,1fr)' }}>
        <h2 style={{ gridColumn:'span 2', fontSize:'1.6rem', fontWeight:900, color:'#7A133D', textAlign:'center' }}>Edit Event</h2>

        <label style={{ display:'flex', flexDirection:'column', gap:'.25rem' }}>
          Community
          <select name="community_id" value={form.community_id} onChange={handleChange} required>
            {(communities ?? []).map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </label>

        <label style={{ display:'flex', flexDirection:'column', gap:'.25rem' }}>
          Category
          <select name="category" value={form.category || ""} onChange={handleChange}>
            <option value="">(Optional)</option>
            {(categories ?? []).map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
          </select>
        </label>

        <label style={{ display:'flex', flexDirection:'column', gap:'.25rem' }}>
          Sub-category
          <select name="sub_category" value={form.sub_category || ""} onChange={handleChange} disabled={!form.category}>
            <option value="">{form.category ? '(Optional)' : 'Choose category first'}</option>
            {(subCategories ?? []).map(sc => <option key={sc.id} value={sc.name}>{sc.name}</option>)}
          </select>
        </label>

        <label style={{ display:'flex', flexDirection:'column', gap:'.25rem' }}>
          Name
          <input name="name" value={form.name} onChange={handleChange} required />
        </label>

        <label style={{ display:'flex', flexDirection:'column', gap:'.25rem' }}>
          Contact
          <input name="contact" value={form.contact} onChange={handleChange} required />
        </label>

        <label style={{ display:'flex', flexDirection:'column', gap:'.25rem' }}>
          Email
          <input name="email" value={form.email} onChange={handleChange} required />
        </label>

        <label style={{ display:'flex', flexDirection:'column', gap:'.25rem', gridColumn:'span 2' }}>
          Address
          <input name="address" value={form.address} onChange={handleChange} required />
        </label>

        <label style={{ display:'flex', flexDirection:'column', gap:'.25rem' }}>
          In-charge
          <input name="in_charge" value={form.in_charge} onChange={handleChange} required />
        </label>

        <label style={{ display:'flex', flexDirection:'column', gap:'.25rem', gridColumn:'span 2' }}>
          Description
          <textarea name="description" rows={3} value={form.description} onChange={handleChange} required />
        </label>

        <div style={{ display:'flex', flexDirection:'column', gap:'.25rem', gridColumn:'span 2' }}>
          <label>Social Links</label>
          {["instagram","facebook","x","youtube","Website"].map(p => (
            <input key={p} placeholder={`${p.toUpperCase()} URL`} value={form.social_links?.[p] || ""}
                   onChange={e => setForm(prev => ({ ...prev, social_links: { ...prev.social_links, [p]: e.target.value }}))} />
          ))}
        </div>

        {error && <p style={{ gridColumn:'span 2', color:'#b91c1c', textAlign:'center', fontWeight:600 }}>{error}</p>}
        <button style={{ gridColumn:'span 2', background:'#C62039', color:'#fff', border:'none', borderRadius:'.5rem', padding:'.6rem', fontWeight:700 }} disabled={loading}>
          {loading ? "Saving…" : "Update"}
        </button>
      </form>
    </section>
  );
}
